import React, {KeyboardEventHandler, useCallback, useMemo, useState} from 'react'
import EntitySelectorSearchInput from "../../search/search-input"
import EntitySelectorSearchRow from "../../search/search-row"

type Props = {
    searchDebounceTime? : number
    onKeyDown           : KeyboardEventHandler
    onSearchChanged     : {(value: string): void}
}

const debug = false
// const debug = "EntitySelectorUsersSearch"

export default function EntitySelectorUsersSearch (props:Props) {
    const {searchDebounceTime = 500} = props

    const [search, setSearch] = useState('')

    const delayedSearch = useMemo(()=>_.debounce((search)=>{
        debug && console.log(debug, 'delayedSearch', search)
        props.onSearchChanged(search)
    }, searchDebounceTime), [])

    const onSearchChange = useCallback((value:string)=>{
        debug && console.log(debug, 'onSearchChange', value)
        setSearch(value)
        delayedSearch(value)
    }, [])

    const onSearchCancel = useCallback(()=>{
        setSearch('')
        delayedSearch('')
    }, [])

    return (
        <EntitySelectorSearchRow>
            <EntitySelectorSearchInput search           = {search}
                                       placeholder      = "Search by user name"
                                       onKeyDown        = {props.onKeyDown}
                                       onSearchChange   = {onSearchChange}
                                       onSearchCancel   = {onSearchCancel}/>
        </EntitySelectorSearchRow>
    )
}
